
import React from 'react';
import { CQAppConstant } from '../../../../../../app-constants';


class RuleComponent extends React.Component<{
    ruleIndex: string;
    ruleData: any,
    lookupFields: any[],
    layoutFields: any[],
    deleteCriteria: any,
    updateRuleData: any,
    selectedReferenceFields: any[]
}> {

    public render() {
        const referenceFields = this.props.selectedReferenceFields.filter((selectedField: any) => {
            return selectedField.fieldName === this.props.ruleData.field;
        });
        return (
            <li key={this.props.ruleIndex} className="slds-expression__row slds-expression__row_group">
                {/* {this.props.ruleIndex} */}
                <fieldset>
                    <div className="slds-grid slds-gutters_xx-small">
                        <div className="slds-col slds-size_3-of-12">
                            <div className="slds-form-element">
                                <div className="slds-form-element__control">
                                    <div className="slds-form-element__control">
                                        <div className="slds-select_container">
                                            <select role="select-lookup-field" className="slds-select" id="select-01"
                                                value={this.props.ruleData.field}
                                                onChange={e => this.props.updateRuleData(e, this.props.ruleIndex, 'field', false)}>
                                                <option value="">Select lookup field</option>
                                                {
                                                    this.props.lookupFields.map((field: any) =>
                                                        <option key={field.name} value={field.name}>{field.label} - {field.name}</option>)
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                !this.props.ruleData.isDynamic && this.props.ruleData.selectedFieldType === 'reference'
                                && referenceFields.length !== 0 &&
                                referenceFields[0].relatedFields.length !== 0 &&
                                <div className="slds-form-element">
                                    <div className="slds-form-element__control">
                                        <div className="slds-form-element__control">
                                            <div className="slds-select_container">
                                                <select role="select-refrence-field" className="slds-select" id="select-01"
                                                    value={this.props.ruleData.referenceField}
                                                    onChange={e => this.props.updateRuleData(e, this.props.ruleIndex, 'referenceField', false)}>
                                                    <option value="">Select reference field</option>
                                                    {
                                                        referenceFields[0].relatedFields.map((field: any) =>
                                                            <option key={field.name} value={field.name}>{field.name}</option>)
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="slds-col slds-size_2-of-12  slds-grow-none">
                            <div className="slds-form-element">
                                <div className="slds-form-element">
                                    {/* <label className="slds-form-element__label">Operator</label> */}
                                    <div className="slds-form-element__control">
                                        <div className="slds-select_container">
                                            <select role="select-operator" className="slds-select"
                                                value={this.props.ruleData.operator}
                                                onChange={e => this.props.updateRuleData(e, this.props.ruleIndex, 'operator', false)}>
                                                <option value="">Please select</option>
                                                {
                                                    CQAppConstant.LOOKFILTER_FIELD_OPERATORS
                                                        .map((operator: { label: string, value: string }, index: number) => {
                                                            return (<option key={index} value={operator.value}>
                                                                {`${operator.label}`}</option>);
                                                        })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="slds-col slds-size_3-of-12">
                            {
                                !this.props.ruleData.isDynamic && this.props.ruleData.selectedFieldType !== 'boolean' &&
                                <div className="slds-form-element">
                                    {/* <label className="slds-form-element__label">Value</label> */}
                                    <div className="slds-form-element__control">
                                        <input role="input-compareto" id=""
                                            type={this.getTextInputTypeBasedOnFieldType(this.props.ruleData.selectedFieldType)}
                                            value={this.props.ruleData.dynamicValue}
                                            onChange={e => this.props.updateRuleData(e, this.props.ruleIndex, 'dynamicValue', false)}
                                            placeholder="Placeholder Text" className="slds-input" />
                                    </div>
                                </div>
                            }

                            {
                                !this.props.ruleData.isDynamic && this.props.ruleData.selectedFieldType === 'boolean' &&
                                <label className="slds-checkbox_toggle">
                                    <input type="checkbox" name="checkbox-toggle-32"
                                        checked={this.props.ruleData.dynamicValue}
                                        aria-describedby="checkbox-toggle-32"
                                        onChange={e => this.props.updateRuleData(e, this.props.ruleIndex, 'dynamicValue', true)} />
                                    <span id="checkbox-toggle-32" className="slds-checkbox_faux_container" aria-live="assertive">
                                        <span className="slds-checkbox_faux"></span>
                                        <span className="slds-checkbox_on">True</span>
                                        <span className="slds-checkbox_off">False</span>
                                    </span>
                                </label>
                            }
                            {
                                this.props.ruleData.isDynamic &&
                                <div className="slds-form-element">
                                    {/* <label className="slds-form-element__label">Value</label> */}
                                    <div className="slds-form-element__control">
                                        <div className="slds-select_container">
                                            <select role="select-compareto" className="slds-select" id="select-01"
                                                value={this.props.ruleData.dynamicValue}
                                                onChange={e => this.props.updateRuleData(e, this.props.ruleIndex, 'dynamicValue', false)}
                                            >
                                                <option value="">Select field</option>
                                                {
                                                    this.props.layoutFields.map(field => <option key={field.fieldFullName}
                                                        value={field.fieldFullName}>
                                                        {`${field.fieldLabel} - ${field.fieldFullName}`}
                                                    </option>)
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="slds-col">
                            <div className="slds-grid slds-m-bottom_xx-small">
                                <label className="slds-checkbox_toggle">
                                    <input role="input-isDynamic" type="checkbox" name="checkbox-toggle-32" value="checkbox-toggle-32"
                                        aria-describedby="checkbox-toggle-32"
                                        checked={this.props.ruleData.isDynamic}
                                        disabled={this.props.ruleData.operator === 'Exists'}
                                        onChange={e => this.props.updateRuleData(e, this.props.ruleIndex, 'isDynamic', false)}
                                    />
                                    <span id="checkbox-toggle-32" className="slds-checkbox_faux_container"
                                        aria-live="assertive">
                                        <span className="slds-checkbox_faux"></span>
                                        <span className="slds-checkbox_on">Dynamic</span>
                                        <span className="slds-checkbox_off">Static</span>
                                    </span>
                                </label>
                                {
                                    !this.checkIfFirstItem(this.props.ruleIndex) &&
                                    <div className="slds-form-element">
                                        <div className="slds-form-element__control">
                                            <button 
                                                className="slds-button slds-button_icon slds-button_icon-border-filled"
                                                onClick={() => { this.props.deleteCriteria(this.props.ruleIndex); }}>
                                                <i className="cq-2x cq-icon-delete"></i>
                                            </button>
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                </fieldset>
            </li >
        );
    }


    private checkIfFirstItem = (nodeName: string) => {
        let isFirstCriteria = false;
        if (nodeName === '0') {
            isFirstCriteria = true;
        } else {
            const nodeArray = nodeName.split('/');
            isFirstCriteria = (nodeArray[nodeArray.length - 1] === '0');
        }
        return isFirstCriteria;
    }

    private readonly getTextInputTypeBasedOnFieldType = (fieldType: string) => {
        let inputType = '';
        switch (fieldType) {
            case 'double':
                inputType = 'number';
                break;
            case 'integer': 
                inputType = 'number';
                break;
            case 'date': 
                inputType = 'date';
                break;
            case 'datetime': 
                inputType = 'datetime-local';
                break;
            case 'string':
                inputType = 'text';
                break;
            default:
                inputType = 'text';
        }
        return inputType;
    }
}



export default RuleComponent;
